(function () {
  var C = window.DSD || {};
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Vaste header
  if (C.sticky) {
    document.body.classList.add('dsd-sticky-on');
    var onScroll = function () { document.body.classList.toggle('dsd-scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // Inschuiven bij scrollen
  if (C.anim && !reduced && 'IntersectionObserver' in window) {
    var sel = '.dsd-sec .dsd-head, .dsd-sec h2.dsd-h, .dsd-tier, .dsd-card, .dsd-box, .dsd-gal > div, .dsd-step, .dsd-faq details, .dsd-usps > div, .dsd-stats > div, .dsd-hero__in > *';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dsd-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.dsd-drawer') || el.closest('.dsd-pp')) return;
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.matches(sel); });
      var i = Math.min(sibs.indexOf(el), 5);
      el.classList.add('dsd-rv'); el.style.transitionDelay = (i * 0.08) + 's';
      io.observe(el);
    });
  }

  // Optellende cijfers
  if (C.anim && !reduced && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, m = el.textContent.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
        if (!m) return;
        var pre = m[1], num = m[2], post = m[3], comma = num.indexOf(',') > -1, dec = (num.split(/[.,]/)[1] || '').length;
        var target = parseFloat(num.replace(',', '.')), t0 = null, dur = 1200;
        function step(t) {
          if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1), v = target * (1 - Math.pow(1 - p, 3));
          var s = v.toFixed(dec); if (comma) s = s.replace('.', ',');
          el.textContent = pre + s + post; if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.dsd-stats b').forEach(function (b) { cio.observe(b); });
  }

  // Afteller tot de besteldeadline (Nederlandse tijd)
  var dagen = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  function nowNL() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); }
  window.dsdCountdown = function () {
    var els = document.querySelectorAll('[data-dsd-countdown]'); if (!els.length) return;
    var n = nowNL(), cutH = C.cutoff || 24, cut = new Date(n);
    cut.setHours(cutH, 0, 0, 0);
    if (cut <= n) cut.setDate(cut.getDate() + 1);
    var mins = Math.max(1, Math.round((cut - n) / 60000)), h = Math.floor(mins / 60), m = mins % 60;
    var tijd = (h ? h + ' uur en ' : '') + m + ' min';
    var ship = new Date(n); ship.setHours(12, 0, 0, 0); ship.setDate(ship.getDate() + 1);
    if (C.skipSun && ship.getDay() === 0) ship.setDate(ship.getDate() + 1);
    var diff = Math.round((ship - new Date(n.getFullYear(), n.getMonth(), n.getDate(), 12)) / 86400000);
    var dag = diff <= 1 ? 'morgen' : dagen[ship.getDay()];
    var txt = (C.countdownText || 'Bestel binnen {tijd}, dan gaat hij {dag} de deur uit').replace('{tijd}', '<b>' + tijd + '</b>').replace('{dag}', '<b>' + dag + '</b>');
    els.forEach(function (el) { el.innerHTML = '● ' + txt; });
  };
  window.dsdCountdown(); setInterval(window.dsdCountdown, 30000);
})();